var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-27.000000, -750.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 563.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.000000, 136.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.500000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99166667,0.5 L8.99166667,1.5 L1.5,1.5 C1.25454011,1.5 1.05039163,1.67687516 1.00805567,1.91012437 L1,2 L1,12 C1,12.2454599 1.17687516,12.4496084 1.41012437,12.4919443 L1.5,12.5 L11.5,12.5 C11.7454599,12.5 11.9496084,12.3231248 11.9919443,12.0898756 L12,12 L12,4.77852083 L13,4.77852083 L13,12 C13,12.7796961 12.4051119,13.4204487 11.64446,13.4931334 L11.5,13.5 L1.5,13.5 C0.720303883,13.5 0.0795513218,12.9051119 0.00686657806,12.14446 L0,12 L0,2 C0,1.22030388 0.594888083,0.579551322 1.35553999,0.506866578 L1.5,0.5 L8.99166667,0.5 Z M8.99166667,8.33204167 L8.99166667,9.55704167 L4.5,9.55704167 L4.5,8.33204167 L8.99166667,8.33204167 Z M12.4163583,0 L13.2854958,0.863339167 L7.20079833,6.988625 L6.33166083,6.125245 L12.4163583,0 Z"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormEdit);
export default __webpack_public_path__ + "static/media/formEdit.cb860c4aad1a8c7918ffbd1daf9a6c85.svg";
export { ForwardRef as ReactComponent };